// @ts-strict-ignore
import { LMFormatterService } from './lm-formatter.service';

export const lmTreeFormatter = (
  lmFormatterService: LMFormatterService,
  row: number,
  cell: number,
  value: any,
  columnDef: ListGridColumn,
  dataView: LMListDataView,
  dataGrid: SohoDataGridStatic
): string  => {

  if (dataView.isTreeMoreLink) {
    const moreColumnIndex = dataGrid?.settings.selectable === 'single' ? 0 : 1;
    return lmFormatterService.getMoreLink(cell, dataView, moreColumnIndex);
  }

  if (columnDef.displayField.visibility) {
    if (!lmFormatterService.isConditionValid(columnDef.displayField.visibility, dataView)) {
      value = '';
    }
  }

  return lmFormatterService.formatForDisplay(row, cell, value, columnDef, dataView, dataGrid);
};
